<template>
  <div class="sidebox" v-if="$route.meta.hasSidebox">
    <help-box />
    <quote />
  </div>
</template>

<script>
import Quote from '@/components/on-board/Quote'
import HelpBox from '@/components/on-board/HelpBox'

export default {
  name: 'OnboardSideBox',
  components: {
    Quote,
    HelpBox
  }
}
</script>

<style lang="scss">
.sidebox {
  display: flex;
  flex-wrap: wrap;
  padding: 60px 20px;
  position: fixed;
  top: 0;
  right: 0;
  max-width: 300px;
  min-width: 280px;
  background: linear-gradient(var(--rosa-eco), #b1276c);
  transition: 0.5s;
}

@media (max-width: 1024px) {
  .sidebox {
    transform: translateX(100%);
    transition: 0.5s;
  }
}
</style>
